import React, { Component } from 'react';
import PropTypes from 'prop-types';
import API_URL from '../../../../common/url';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';
import ChartsCollection from '../components/ChartsCollection';

const countType = 3;
const Icons = [{ icon: '\ue656', order: 0 }, { icon: '\ue659', order: 1 }, { icon: '\ue651', order: 2 }];
function getCharts(type, angle) {
    const chartTitle = angle === '0' ? '确认收款金额' : '请款笔数';
    return (
        [{
            title: '超账期天数',
            chartTitle,
            type,
            key: 'overPaymentDays',
            queryUrl: API_URL.requestDataAnalysis.queryOutCashReqNodeDaysCount,
            exportUrl: API_URL.requestDataAnalysis.exportOutCashReqNodeDaysCount,
        }, {
            title: '超期原因',
            chartTitle,
            type,
            key: 'overPaymentReason',
            queryUrl: API_URL.requestDataAnalysis.queryRemark,
            exportUrl: API_URL.requestDataAnalysis.exportRemark,
        }, {
            title: '客户',
            chartTitle,
            type,
            key: 'client',
            queryUrl: API_URL.requestDataAnalysis.queryCustomer,
            exportUrl: API_URL.requestDataAnalysis.exportCustomer,
        }]
    );
}
const year = new Date().getFullYear();
const beginOfYear = `${year}-01-01`;
const endOfYear = `${year}-12-31`;

class ReturnedData extends Component {
    static contextTypes = {
        businessList: PropTypes.array,
        clientHeight: PropTypes.number,
        notice: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            searchParams: {
                type: '0',
                returnedDateStart: beginOfYear,
                returnedDateEnd: endOfYear,
            },
        };
    }

    handleIconChange = (current) => {
        this.setState({ current });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    render() {
        const { businessList, clientHeight, notice } = this.context;
        const { current, searchParams } = this.state;
        const { type } = searchParams;

        return (
            <div className="pane-item">
                <HeaderBar
                    title="回款数据分析"
                    tip="系统中已回款的请款记录"
                    onChange={this.handleIconChange}
                    current={current}
                    icons={Icons}
                />
                {
                    current === 0 &&
                    <ChartsCollection
                        countType={countType}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                        charts={getCharts('pie', type)}
                    />
                }
                {
                    current === 1 &&
                    <TablePage
                        notice={notice}
                        searchParams={searchParams}
                        businessList={businessList}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                    />
                }
                {
                    current === 2 &&
                    <ChartsCollection
                        countType={countType}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                        charts={getCharts('histogram', type)}
                    />
                }
            </div>
        );
    }
}

export default ReturnedData;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/ReturnedData/index.js